/**
 * Get the full asset image URL by combining the asset host and relative image path.
 *
 * @param {string} relativeImagePath - The relative path of the image.
 * @returns {string} The full URL of the asset image.
 */
const getAssetImage = (relativeImagePath: string, subfolder?: string) => {
  const { brand, assethost } = useEnvProps();

  return relativeImagePath ? `${assethost}/images/${subfolder || brand}/${relativeImagePath}` : '';
};

export default getAssetImage;
